import gql from 'graphql-tag'

export const CREATE_REFERRAL = gql`
  mutation CreateReferral($eventId: ID!, $name: String!) {
    createReferral(name: $name, eventId: $eventId) {
      id
    }
  }
`

export const GET_EVENT_REFERRALS = gql`
  query Referrals($eventId: ID!) {
    referrals(eventId: $eventId) {
      id
      name
      visits
      registrations
    }
  }
`

export const DELETE_REFERRAL = gql`
  mutation DeleteReferral($id: ID!, $eventId: ID!) {
    deleteReferral(id: $id, eventId: $eventId)
  }
`
